module.exports = __webpack_public_path__ + "assets/img/67_213_2.2ed069a0.jpg";